<template>
  <page-outline :title="$t('administration.user_details')">
    <template slot="primaryActions">
      <app-button
        :text="$t('common.bck')"
        icon="fa-light fa-arrow-left"
        variant="primary"
        @click="goBack">
      </app-button>
    </template>
    <template slot="pageContent">
      <b-container fluid>
        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="User">
          <div class="title-label-blue w-100">{{$t('administration.user_info')}}</div>
          <table class="table">
            <tbody>
                <tr>
                  <th class="text-center w-50">
                    {{ $t('administration.identifier') }}
                  </th>
                  <td class="text-center">
                    {{ User.Login }}
                  </td>
                </tr>
                <tr v-if="User.Name">
                  <th class="text-center w-50">
                    {{ $t('administration.user_name') }}
                  </th>
                  <td class="text-center">
                    {{ User.Name }}
                  </td>
                </tr>
                <tr>
                  <th class="text-center w-50">
                    {{ $t('administration.active') }}
                  </th>
                  <td class="text-center w-50">
                    <i v-if="User.Active == 0" class="fa-duotone fa-xmark btn btn-icon btn-icon-red p-0 min-h-auto"></i>
                    <i v-if="User.Active == 2" class="fa-duotone fa-check btn btn-icon btn-icon-green p-0 min-h-auto"></i>
                    <i v-if="User.Active == 1" class="fa-duotone fa-warning btn btn-icon btn-icon-orange p-0 min-h-auto"></i>
                  </td>
                </tr>
            </tbody>
          </table>
          <br>
          <div class="title-label-blue w-100">{{$t('administration.user_auth')}}</div>
          <table class="table table-striped" v-if="User.Rights && User.Rights.length">
            <tbody>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.company_name') }}
                </th>
                <th class="text-center w-50">
                  {{ $t('administration.profile') }}
                </th>
              </tr>
              <tr v-for="right in User.Rights" :key="right.IdAccount + '-' + right.IdRightProfile">
                <td class="text-center w-50">
                  {{ right.AccountName }}
                </td>
                <td class="text-center w-50">
                  {{ hasProfileTrad(right.RightsProfileName) }}
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </b-container>
    </template>
    <template slot="bottomActions">
      <app-button
        v-if="canUserEdit"
        :text="$t('administration.edit')"
        icon="fa-light fa-pencil"
        variant="primary"
        @click="activateEdit(User.IdUser)">
      </app-button>
      <app-button
        v-if="canUserDelete"
        :text="$t('rights.delete')"
        icon="fa-light fa-trash"
        variant="primary"
        @click="activateDelete(User.IdUser)">
      </app-button>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment-timezone'
import {errorMessageAlert} from '@/helpers/alert'
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage, reloadPage} from '@/helpers/routing'
import AppButton from '@/components/common/AppButton.vue'
import Spinner from '@/components/common/spinner.vue'

export default {
  name: 'DetailUserCompany',
  components: {
    'page-outline': PageOutline,
    'app-button': AppButton,
    'spinner': Spinner
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    canUserDelete () {
      return this.$engine.firstOn().rights.rightIs('usercompany_delete', true) || this.$engine.firstOn().rights.rightIs('usercompany_delete_admin', true)
    },
    canUserEdit () {
      return this.$engine.firstOn().rights.rightIs('usercompany_edit', true) || this.$engine.firstOn().rights.rightIs('usercompany_edit_admin', true)
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return this.$t('administration.user_details')
    }
  },
  props: ['idUserAcc', 'idCompany'],
  data () {
    return {
      activateSpinner: false,
      returnUrl: '/usercompany/',
      User: {}
    }
  },
  created () {
    // this.defineReturnURL()
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.$t('administration.user_details')
      // returnUrl: ''
    })

    this.$engine.firstOn().settings.set({msgDirection: this.direction})
    this.getUser()
    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    defineReturnURL() {
      if (this.idCompany === 'undefined') {
        let that = this
        this.returnUrl =  '/usercompany/'
        this.$engine.firstOn().rights.getAllProfiles()
        .then(resp => {
          that.$engine.firstOn().company.profiles = resp.profiles.map(profile => {
            return {
              id_rights_profile: profile.idProfile,
              libelle: profile.libelleProfile,
              idAccount: profile.idAccount,
              nameAccount: profile.accountName
            }
          })
        })
        .catch(err => {
          return err
        })
      } else {
        this.returnUrl = '/detail/' + this.idCompany
      }
    },
    getUser () {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.firstOn().usercompany.idUserAcc = this.idUserAcc
      this.UsersList = []
      let filterConditions = that.$engine.firstOn().usercompany.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.firstOn().usercompany.getUser(
        this.idUserAcc,
        10,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.users && resp.data.users.length) {
          let userCompany = resp.data.users[0]
          that.User = userCompany
          this.$f7.pullToRefreshDone()
          this.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.activateSpinner = false
      }).catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    activateEdit (ressource) {
      let that = this
      loadPage(that, {url: '/editusercompany/' + ressource + '/' + that.idCompany})
    },
    activateDelete (ressource) {
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('administration.del_user_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.firstOn().usercompany.deleteUser(ressource)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_user'))
                reloadPage(that, {url: '/detail/' + that.idCompany})
              }).catch(e => {
                errorMessageAlert(e, that)
                that.$f7.modal({
                  title: that.$i18n.t('administration.del_error'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    hasProfileTrad (profileName) {
      // Accéder directement aux messages pour éviter les problèmes avec les espaces dans les clés
      const locale = this.$i18n.locale
      const messages = this.$i18n.messages[locale]
      
      // Vérifier si la traduction existe
      if (messages && messages.rights && messages.rights.db_profiles && messages.rights.db_profiles[profileName]) {
        return messages.rights.db_profiles[profileName]
      }
      
      // Si pas de traduction trouvée, retourner le nom original
      return profileName
    },
    goBack() {
      loadPage(this, {url: this.returnUrl})
    }
  }
}
</script>
